import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CompanyService {
    constructor(private http: HttpClient) {
    }

    public getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'company/getAll').subscribe(data => {
                resolve(data);
            }, error => {
                ////console.log(error);
                reject();
            });
        });
  }
  public get(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'company/GetById?Id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public updateMessage(id: string, title: string, message: string, userId: string): Promise<any> {

    var params = {
      company_Id: id,
      title: title,
      message: message,
      userId: userId,
    }

    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'company/updateMessage', params).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public addorupdate(company): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'company/post', company).subscribe(data => {
        resolve(data);
      }, error => {
        reject();
      });
    });

  }
}
